import { CSSProperties, useMemo, useState } from "react";
import { createSearchParams, NavLink } from "react-router-dom";
import { AttentionTypes, CreateAttentionStyles, NavLinkTypes } from "../../../Definitions";
import { useTranslation } from "react-i18next";
import { CreateNavLinkStyle } from "../../../Definitions/navLinkTypes";
import { useAppSelector } from "../../../Store";
import { IS_CLOUD } from "../../../app";
import { colors, fonts } from "../../../Styles";

interface Button_Props_overrides {
  baseButton?: CSSProperties
  hoverStyles?: CSSProperties
  iconStyles?: CSSProperties
  hoverEnhancerStyles?: CSSProperties
  contentStyles?: CSSProperties
  subContentStyles?: CSSProperties
  hoverSubContentStyles?: CSSProperties
  childrenStyles?: CSSProperties
}

interface CoreNavLink_Props{
  tabIndex?: number;
  content: string
  subContent?: string
  path: string
  endPath?: boolean
  icon?: JSX.Element | string
  navLinkType?: NavLinkTypes
  disabled?: boolean
  focus_view?: boolean
  attentionType?: AttentionTypes
  overrides?: Button_Props_overrides
  additionalOnclik?: () => void
  pushActiveStyles?: boolean
}

export default function CoreNavLink({ tabIndex, content, subContent, path, endPath = false, icon, navLinkType, disabled = false, focus_view = false, attentionType, overrides, additionalOnclik, pushActiveStyles }: CoreNavLink_Props) {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const { baseStyles, hoverStyles, iconStyles, contentStyles, childrenStyles, subContentStyles, hoverSubContentStyles, hoverIconStyles } = useMemo(() => CreateNavLinkStyle(navLinkType, attentionType, focus_view, overrides), [navLinkType, attentionType, focus_view, overrides]);

  // #region | Handle enhancers based on type
  const _iconFromType = (enhancer: JSX.Element | string | undefined, enhancerStyles: CSSProperties) => {
    if (!enhancer) return null;
    return typeof enhancer === "string" 
      ? <img alt="enhancer" src={enhancer} style={{ ...enhancerStyles, width: "40px" }} />
      : enhancer;
  }

  const iconFromType = _iconFromType(icon, iconStyles);
  // #endregion

  const { textColor, attentionText, attentionColor } = CreateAttentionStyles(t, attentionType);
  const attentionBlock = (<div style={{ width: focus_view ? "90px" : "80px", height: focus_view ? "60px" : "50px", backgroundColor: attentionColor, display: "flex", alignItems: "center", boxSizing: "border-box", padding: "10px" }}><p style={{...(focus_view ? fonts.fontSize3 : fonts.fontSize4), ...fonts.header, color: textColor}}>{attentionText}</p></div>)
  
  const domain = useAppSelector(({ activeData }) => {if (!IS_CLOUD) {return activeData.farm}}) ?? "";
  const search = domain ? createSearchParams({domain}).toString() : undefined;  
  return (
    // <li style={{width: "fit-content", height: "fit-content"}}>
    <div style={{position: "relative", width: (navLinkType === NavLinkTypes.systemNavLink || navLinkType === NavLinkTypes.attentionListItem) ? "100%" : "fit-content", height: "fit-content"}}>
      <NavLink
        tabIndex={tabIndex}
        onClick={additionalOnclik}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        to={{pathname: path, search}}
        end={endPath}
        style={({isActive}) => (
          (isActive||isHovered||pushActiveStyles) ? {...baseStyles, ...hoverStyles} : {...baseStyles}
        )}
        children={({ isActive }) => (
          <div style={{ ...childrenStyles }}>
            {attentionType !== undefined ? attentionBlock : <></>}
            { icon ? <div style={(isHovered || isActive || pushActiveStyles) ? { ...iconStyles, ...hoverIconStyles} : { ...iconStyles } }> {iconFromType} </div> : <></>}
            <div style={{ display: "flex", flexDirection: "column", gap: "2px", boxSizing: "border-box", borderLeft: ((isHovered || isActive) && navLinkType === NavLinkTypes.attentionListItem && !focus_view) ? "2px solid "+colors.greyDarkPrimary : (navLinkType === NavLinkTypes.attentionListItem && !focus_view) ? "2px solid "+colors.greyDarkSecondary : "none", paddingLeft: navLinkType === NavLinkTypes.attentionListItem ? "10px" : "0px"}}>
              <p style={{ ...contentStyles }}>{content}</p>
              {!subContent ? <></> : <p style={isHovered||isActive ? { ...subContentStyles, ...hoverSubContentStyles } : { ...subContentStyles }}>{subContent}</p>}
            </div>
          </div>
        )}
      />
      {disabled ? <div style={{position: "absolute", top: "0", left: "0", width: "100%", height: "100%", backgroundColor: colors.transparent, borderRadius: "10px", cursor: "not-allowed"}}/> : <></>}
    </div>
    // </li>
  );
}


